import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const HeaderSection = styled.section`
  display: flex;
  margin-bottom: 2rem;
  justify-content: space-between;
  align-items: flex-start;

  > aside {
    display: flex;
    gap: 1rem;
  }
`;

export const SectionContainer = styled.section`
  position: relative;
  width: 100%;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  box-shadow: ${props => props.theme.shadows.primary};
  border-radius: ${props => props.theme.radius.primary};
  padding: 2rem;
  margin-bottom: 1.5rem;
`;

export const ExerciseNavigation = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid ${props => props.theme.colors.muted}20;
`;

interface ICardQuestionProps {
  current: boolean;
  isDragging?: boolean;
}

export const CardQuestion = styled.div<ICardQuestionProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 1rem;
  border-radius: 50%;
  font-weight: bold;
  color: ${props => props.theme.colors.white};
  background: ${props => props.current ? props.theme.colors.primary || '#5562eb' : `${props.theme.colors.muted}30`};
  cursor: grab;
  transition: all 0.2s ease-in-out;
  border: 2px solid ${props => props.current ? props.theme.colors.primary || '#5562eb' : 'transparent'};
  animation: ${props => props.current ? 'pulseAnimationCss 2s infinite' : 'unset'};

  &:hover {
    opacity: 0.8;
  }

  ${props => props.isDragging && css`
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    opacity: 0.9;
    cursor: grabbing;
  `}

  @keyframes pulseAnimationCss {
    0% {
      box-shadow: 0 0 0 0 ${props => props.theme.colors.muted}50;
    }
    70% {
      box-shadow: 0 0 0 10px ${props => props.theme.colors.muted}10;
    }
    100% {
      box-shadow: 0 0 0 0 ${props => props.theme.colors.muted}10;
    }
  }
`;

export const AddExerciseCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 1rem;
  border-radius: 50%;
  font-weight: bold;
  color: ${props => props.theme.colors.white};
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: 2px dashed ${props => props.theme.colors.muted}60;

  &:hover {
    background: ${props => props.theme.colors.muted}20;
  }
`;

export const Separator = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 2rem;
  gap: 1rem;
  width: 100%;

  > h2 {
    font-size: 14px;
    font-weight: 500;
  }

  > section {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    > main {
      position: relative;
      width: 100%;
      padding-left: 1rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 1rem;

      > div {
        width: 200px;
      }
    }
  }
`;

export const LineInfoQuestions = styled.section`
  position: relative;
  width: 100%;
  display: grid;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  margin: 0 0 2rem 0;
  grid-template-columns: 3fr 1fr 1fr;

  > div {
    width: 100%;
  }
`;

export const LineField = styled.section`
  position: relative;
  width: 100%;
  display: grid;
  gap: 1rem;
  margin-bottom: 2rem;
  grid-template-columns: 1fr;

  > div {
    width: 100%;

    > h4 {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
  }
`;

export const LineCorrectOption = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;

  > main {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    font-weight: 500;
    font-size: 14px;

    > div {
      width: 200px;
    }
  }
`;

export const LineButtons = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${props => props.theme.colors.muted}20;

  > div {
    display: flex;
    gap: 1rem;
  }

  > button {
    height: 50px;
    min-width: 160px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  gap: 1.5rem;

  > p {
    font-size: 16px;
    color: ${props => props.theme.colors.muted};
  }
`;
